@if (file$ | async; as file) {
  @if (isIssdActivity && issdApplication) {
    <icz-tag [label]="issdApplication!.name" color="orange" class="mr-16" (click.stop)="openUrl(issdApplication!.urlAddress)" [ngClass]="{'clickable-tag': issdApplication!.urlAddress}"></icz-tag>
  }
  @if (isFileReadyForAgendaTransfer) {
    <icz-tag label="Připraveno k rozluce" color="orange" class="mr-16"></icz-tag>
  }
  @if (isFileLost) {
    <icz-tag label="Ztraceno" color="grey" class="mr-16"></icz-tag>
  }
  @if (isAgendaTransferConfirmed) {
    <icz-tag label="Rozluka potvrzena" color="orange" class="mr-16"></icz-tag>
  }
  <div class="big-icon-container">
    @if (isFileDeleted) {
      <icz-icon class="deleted" svgIcon="destroyed" size="small"></icz-icon>
    }
    <icz-icon [svgIcon]="bigIcon" [iczTooltip]="'en.objectClass.' + file.objectClass"></icz-icon>
  </div>
  <div class="col grow">
    <div class="row">
      @if ((canDisplayFileProfile$ | async) === false && applicationConfigService.objectExistenceCheckObjectMetadataVisible()) {
        <icz-tag color="grey" label="Omezený náhled" svgIcon="eye"></icz-tag>
      }
      @if (object.fileState && object.fileState !== FileState.OPEN) {
        <icz-tag [label]="'en.fileState.' + file.fileState" [color]="getObjectTagColor($any(file))"></icz-tag>
      }
      @if (!isIssdActivity) {
        @if ((canDisplayFileActivities$ | async) && runningActivity) {
          <icz-task-activity-state-icon
            [activity]="runningActivity"
            (circulationActionCompleted)="onCirculationActionCompleted()"
          ></icz-task-activity-state-icon>
        }
      }
      @if (isRegistryOfficeTransferActivityView) {
        <icz-tag [color]="registryOfficeTransferTagColor" [label]="registryOfficeTransferTagLabel"></icz-tag>
      }
      @if (isSharedInAccessibleFolder$ | async) {
        <icz-tag color="blue" label="Ve složce" svgIcon="substitute"></icz-tag>
      }
      @if (showConfidentialIcon) {
        <icz-icon svgIcon="confidential" size="small"></icz-icon>
      }
      @if (file.uid?.uid; as uid) {
        <icz-label class="uuid" [label]="uid"></icz-label>
      }
    </div>
    <div class="truncate">
      @if (file.refNumber; as refNumber) {
        <span class="ref-number">{{ refNumber }}</span>
      }
      @if (file.subject) {
        <span class="font-bold" [iczTooltip]="file.subject">
          @if (file.refNumber) {
            -
          }
          {{ file.subject }}
        </span>
      }
    </div>
  </div>
  @if (
    isAuthorizedOperationGranted(file.authorization, FileAuthorizedOperation.FILE_SHOW_PROFILE) &&
    file.fileState !== FileState.DELETED
    ) {
    @if (isInCirculationSolvingMode) {
      <icz-circulation-toolbar-buttons
        [view]="circulationToolbarView"
        [selectedRows]="[file]"
        [refActivity]="refActivity"
        [refTask]="refTask"
      ></icz-circulation-toolbar-buttons>
    }
    @else {
      <icz-file-toolbar-buttons
        [view]="DocumentView.DOCUMENT_DETAIL"
        [selectedRows]="[file]"
        [isRegistryOfficeTransferActivityView]="isRegistryOfficeTransferActivityView"
      ></icz-file-toolbar-buttons>
    }
  }
  <div class="div-splitter"></div>
  <icz-entity-comments-viewer [isInTable]="false" [file]="object" [disabled]="!allowComments"></icz-entity-comments-viewer>
}
